const schema = () => ({
  type: "object",
  required: [],
  properties: {
    national_identifier: {
      type: "string",
      title: "شناسه ملی",
      pattern: "^[0-9]*$",
      minLength: 5,
      maxLength: 16,
    },
    medical_number: {
      type: "string",
      title: "شماره نظام پزشکی",
      pattern: "^[0-9]*$",
      minLength: 5,
      maxLength: 16,
    },
    specialist: {
      type: "string",
      title: "تخصص",
      oneOf: [
        {
          const: "generalDentist",
          title: "دندانپزشک عمومی",
        },
        {
          const: "orthodontist",
          title: "متخصص ارتودنسی",
        },
        {
          const: "endodontist",
          title: "متخصص درمان ریشه",
        },
        {
          const: "prosthodontist",
          title: "متخصص پروتزهای دندانی و ایمپلنت",
        },
        {
          const: "pedodontist",
          title: "متخصص دندانپزشکی کودکان",
        },
        {
          const: "oralAndMaxillofacialRadiologist",
          title: "متخصص رادیولوژی دهان، فک و صورت",
        },
        {
          const: "oralAndMaxillofacialSurgeon",
          title: "متخصص جراحی دهان، فک و صورت",
        },
        {
          const: "periodontist",
          title: "متخصص جراحی لثه و ایمپلنت",
        },
        {
          const: "restorativeAndAestheticDentist",
          title: "متخصص دندانپزشکی ترمیمی و زیبایی",
        },
        {
          const: "oralAndMaxillofacialPathologist",
          title: "متخصص آسیب شناسی دهان، فک و صورت",
        },
      ],
    },
    location: {
      type: "object",
      title: "آدرس",
      properties: {
        lat: {
          type: "string",
        },
        lng: {
          type: "string",
        },
        state: {
          type: "string",
        },
        city: {
          type: "string",
        },
      },
    },
    registered_number: {
      type: "string",
      title: "شماره ثبت",
      pattern: "^[0-9]*$",
    },
    register_date: {
      type: "string",
      title: "تاریخ ثبت",
    },
    tellphone: {
      type: "string",
      title: "تلفن",
      pattern: "^09[0-9]{9}$",
    },
    email: {
      type: "string",
      title: "ایمیل",
    },
    site_url: {
      type: "string",
      title: "وبسایت",
      format: "url"
    },
    postal_code: {
      type: "string",
      title: "کدپستی",
      pattern: "[0-9]{10}$",
    },
    address: {
      type: "string",
      title: "آدرس",
    },
    details: {
      type: "string",
      title: "درباره ما",
    },
  },
});

export default schema;
